import React from "react";
import { Form, useAPI, Card, Loader } from "components/lib";

export function KYBView() {
  const [success, setSuccess] = React.useState(false);
  const [report, setReport] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

return (
    <div>
        <div title="Refer a friend" className="w-1/2 bg-slate-100">
            <Form
                data={{
                    countryCode: {
                        type: "select",
                        options: [
                            { label: "United States", value: "US" },
                            { label: "United Kingdom", value: "GB" }
                        ],
                        required: true,
                        errorMessage: "Please select a jurisdiction",
                        label: "Jurisdiction",
                    },
                    registrationCode: {
                        type: "text",
                        required: true,
                        errorMessage: "Please enter the registration code",
                        label: "Registration Code",
                    },
                }}
                buttonText="Get KYB Report"
                method="POST"
                url="/api/v1/verification/namescan/kyb"
                callback={(res) => {
                    setSuccess(res.data);
                    console.log("KYB Report:", res.data);
                    setReport(res.data.data.report);
                }}
            />
        </div>
        {isLoading && <Loader />}
        {success && (
            <div>
                <br />
                <br />
                <Card title="Success" className="">
                    <p>Your KYB report has been generated successfully</p>
                    {report && (
                        <div>
                            <h2>Report Details:</h2>
                            <div dangerouslySetInnerHTML={{ __html: report }} />
                        </div>
                    )}
                </Card>
            </div>
        )}

        <div>
            <br />
            <Card className="w-1/2 bg-slate-100 pt-2">
            </Card>
        </div>
    </div>
);
}
